import React from "react";

type Props = {
  width: number;
  height: number;
};

export const AdOffericonSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 24 24.01`}
      fill="currentColor"
      opacity="0.6"
    >
      <path d="M14.76,4.4,15.92,7l-4.47,4.47a.77.77,0,0,0,0,1.09.76.76,0,0,0,.55.23.78.78,0,0,0,.55-.23L17,8.08l2.6,1.16a1.12,1.12,0,0,0,.31,0,1.08,1.08,0,0,0,.7-.29L23.7,5.92a1,1,0,0,0,0-1.41.91.91,0,0,0-.37-.24l-2.7-.9L19.72.68A1,1,0,0,0,18.78,0a1,1,0,0,0-.7.29L15,3.38a1.13,1.13,0,0,0-.29.7A1.25,1.25,0,0,0,14.76,4.4ZM18.54,2l.62,1.84.24.73.74.25L22,5.46,19.81,7.64,17.43,6.58,16.37,4.2Zm4.9,6.35L22.17,9.65A10.34,10.34,0,0,1,22.45,12,10.5,10.5,0,1,1,14.36,1.83L15.62.56A14.29,14.29,0,0,0,12,0h0a12,12,0,0,0,0,24h0A12,12,0,0,0,23.44,8.38ZM13.29,4.88a3.32,3.32,0,0,1-.13-.7A7.47,7.47,0,0,0,12,4.07,7.94,7.94,0,0,0,4.06,12h0A7.91,7.91,0,0,0,12,19.94h0A7.93,7.93,0,0,0,19.93,12h0a7.73,7.73,0,0,0-.11-1.18,2.69,2.69,0,0,1-.7-.11c-.1,0,0,0-1-.44A5.94,5.94,0,0,1,18.38,12,6.39,6.39,0,1,1,12,5.62a6.31,6.31,0,0,1,1.73.27c-.16-.33-.31-.66-.44-1ZM12,8.13A3.88,3.88,0,1,0,15.87,12a3.29,3.29,0,0,0,0-.54l-2.18,2.18h0a2.32,2.32,0,0,1-4-1.64,2.28,2.28,0,0,1,.68-1.64h0l2.17-2.18A4.52,4.52,0,0,0,12,8.13Z" />
    </svg>
  );
};
